import { createContext } from "react";
import { DemandPlanEditsContextType } from "./type";

export const DemandPlanEditsContext = createContext<DemandPlanEditsContextType>(
  {
    plannerOverrideInputs: {},
    finalForecastInputs: {},
    yoyPercentageInputs: {},

    editMode: false,
    loading: false,

    setPlannerOverrideInputs: () => {},
    setFinalForecastInputs: () => {},
    setYoYPercentageInputs: () => {},

    setEditMode: () => {},
    saveEditsAndTriggerRun: async () => {},
    discardChanges: () => {},
  }
);
